import React, { FC } from 'react'
import styles from './DropDownMenu.module.scss'
import { Stack } from 'components/Stack'
import { Heading } from 'components/Heading'
import { DropDownElement } from 'components/DropDownElement'

type DropDownMenuProps = {
  label: string
  options: any
  value: string | number | undefined
  onChange: any
  instructionLabel: string
}

export const DropDownMenu: FC<DropDownMenuProps> = ({
  label = '',
  options = [],
  value = '',
  onChange = '',
  instructionLabel,
}) => {
  return (
    <div>
      <label>
        <Stack space="medium">
          <Heading size="widget">{label}</Heading>
        </Stack>
        <br />
        <Stack space="medium">
          <select value={value} onChange={onChange} className={styles.dropDownMenu}>
            <DropDownElement value="undefined" label={instructionLabel} />
            {options}
          </select>
        </Stack>
      </label>
    </div>
  )
}

DropDownMenu.displayName = 'DropDownMenu'
